import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';

export class NgbDateUtils {
  /**
   * Checks if current date is equal to another date
   */
  static equals(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return date1 && date2 && date1.year === date2.year && date1.month === date2.month && date1.day === date2.day;
  }

  /**
   * Checks if current date is before another date
   */
  static before(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    if (!date1 || !date2) {
      return false;
    }

    if (date1.year === date2.year) {
      if (date1.month === date2.month) {
        return date1.day === date2.day ? false : date1.day < date2.day;
      } else {
        return date1.month < date2.month;
      }
    } else {
      return date1.year < date2.year;
    }
  }

  /**
   * Checks if current date is after another date
   */
  static after(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    if (!date1 || !date2) {
      return false;
    }
    if (date1.year === date2.year) {
      if (date1.month === date2.month) {
        return date1.day === date2.day ? false : date1.day > date2.day;
      } else {
        return date1.month > date2.month;
      }
    } else {
      return date1.year > date2.year;
    }
  }

  /**
   * Checks if current date is equals or after another date
   */
  static equalOrAfter(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return NgbDateUtils.equals(date1, date2) || NgbDateUtils.after(date1, date2);
  }

  /**
   * Checks if current date is equals or before another date
   */
  static equalOrBefore(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return NgbDateUtils.equals(date1, date2) || NgbDateUtils.before(date1, date2);
  }

  /**
   * this method used to parse date in NgbDateStruct to timestamp format
   * ex: {year: 2018, month: 9, date: 19} to 1537344045325
   * @param {{year: number; month: number; day: number}}
   */
  static parseDate(date: NgbDateStruct) {
    if (!date) {
      return null;
    }
    // JavaScript counts months from 0 to 11. (January is 0. December is 11)
    return (new Date(date.year, date.month - 1, date.day).getTime());
  }

  /**
   * this method used to parse date in NgbDateStruct to timestamp format
   * ex: {year: 2018, month: 9, date: 19} to 1537344045325
   * @param {{year: number; month: number; day: number}}
   */
  static convertNgbDate(date: Date) {
    if (!date) {
      return null;
    }
    // JavaScript counts months from 0 to 11. (January is 0. December is 11)
    return NgbDate.from({
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/ngb-date.utils.ts